import { Badge, memberStatusTone } from '@platform/design-system';
import type { Subsidiary } from '../settings/subsidiaries.ts';
import { usePageContext } from '../usePageContext.ts';
import { statusOf, type Member } from './team.ts';

export type MemberBadgesProps = { member: Member; self: boolean; subsidiaries: readonly Subsidiary[] };

export const MemberBadges = ({ member, self, subsidiaries }: MemberBadgesProps) => {
  const { t } = usePageContext();
  const status = statusOf(member);
  const subsidiary = subsidiaries.find((candidate) => candidate.id === member.subsidiaryId);
  return (
    <>
      {self ? <Badge tone="brand">{t('team.you')}</Badge> : null}
      <Badge tone="info">
        {member.preset === null ? t('team.noPreset') : t(`team.preset_${member.preset}`)}
      </Badge>
      {status === 'active' ? null : (
        <Badge tone={memberStatusTone[status]}>{t(`team.status_${status}`)}</Badge>
      )}
      {subsidiary === undefined ? null : <Badge>{subsidiary.name}</Badge>}
      {member.managedOutside ? <Badge>{t('team.outside')}</Badge> : null}
    </>
  );
};
